"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateCapacity = void 0;
const estimateCapacity = (state, bedTypes) => {
    const capacityByType = bedTypes ? Object.fromEntries(bedTypes.map(x => [x.name, x.capacity])) : [];
    const allBeds = Object.values(state.rooms).reduce((collect, bedroom) => [...collect, ...bedroom.beds], state.extraBeds);
    return allBeds.reduce((total, bed) => { var _a; return total + ((_a = capacityByType === null || capacityByType === void 0 ? void 0 : capacityByType[bed.bed_type]) !== null && _a !== void 0 ? _a : 1); }, 0);
};
exports.estimateCapacity = estimateCapacity;
//# sourceMappingURL=capacity.js.map